import Repository from "../Repository";

const resource = "/users";
export default {
    get() {
        return Repository.get(`${resource}`);
    },
    getUserByMail(mail) {
        return Repository.get(`${resource}`, {
            params: {
                mail: mail
            }
        });
    },
    createUser(json) {
        let data = JSON.parse(JSON.stringify(json)); //darf keine referenz sein. Deshalb copy
        // eslint-disable-next-line no-undef
        data.user = sso.getSsoUser();
        return Repository.post(`${resource}`, data);
    },
    update(id, json = null) {
        let data = json;
        if (data === null) { //just update sso_id
            // eslint-disable-next-line no-undef
            let user = sso.getSsoUser();
            data = {user: user, id: user.id, sso: true};
        }
        return Repository.put(`${resource}/` + data.id, data);
    },
    delete(id) {
        return Repository.delete(`${resource}/${id}`);
    }
}